import { render, staticRenderFns } from "./WalletEditProvider.vue?vue&type=template&id=6a8b54b9&"
import script from "./WalletEditProvider.vue?vue&type=script&lang=ts&"
export * from "./WalletEditProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports